'use client';

import { useNavigate } from 'react-router-dom';
import { PrivyLoginButton } from '@/components/privy-login-button';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

export function LoginTips({
    className,
    nextUrl,
    hideButton = false
}: { className?: string, nextUrl?: string, hideButton?: boolean }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className={cn(
            'flex items-center justify-center flex-wrap px-4 min-h-[40px] text-sm gap-x-2 gap-y-1',
            className
        )}>
            <p className='m-0 leading-snug'>
                <span
                    className='text-primary whitespace-nowrap mr-1'
                >
                    {t('loginTips.login')}
                </span>
                {t('loginTips.interactDesc')}
            </p>
            {!hideButton && (
                <PrivyLoginButton className='h-6 px-2 rounded-lg text-xs min-w-fit'/>
            )}
        </div>
    );
}
